import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { apiFetch, syncSessionProfile } from '@/shared/api/client';
import { STALE_TIME_SHORT } from '@/shared/config';
import type { UserProfile } from '../model/types';
import { userKeys } from './keys';

/**
 * Loads the current user profile and keeps the local session in sync.
 * Cached briefly so back-and-forth navigation doesn't refetch.
 */
export const useProfile = () => {
  const query = useQuery<UserProfile>({
    queryKey: userKeys.profile(),
    queryFn: () => apiFetch<UserProfile>('/api/settings/profile'),
    staleTime: STALE_TIME_SHORT,
  });

  useEffect(() => {
    if (query.data) {
      syncSessionProfile(query.data);
    }
  }, [query.data]);

  return query;
};
